import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource } from "../linkers/types";
import { Identifiable, Resource } from "@planzone/dto";

type Response = {
  _embedded: {
    resources: LinkedResource<Identifiable<Resource>>[];
  };
  page: {
    size: number;
    totalElements: number;
    totalPages: number;
    number: number;
  };
};

function getResourceSubordinates(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>, page: number, size: number) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/resources/search/subordinates?managerUuid=${resource.uuid}&page=${page}&size=${size}`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded, page: pageInfo }) =>
        Promise.all(
          _embedded.resources.map((resource) => ({
            ...resource,
            tags: resource.tags
              ? resource.tags.map((tag) => {
                  // @ts-ignore
                  return typeof tag === "string" ? { name: tag } : tag;
                })
              : [],
          })),
        ).then((resources) => ({
          resources,
          currentPage: pageInfo.number + 1,
        })),
      )
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getResourceSubordinates };
